import { CalendarBlank } from '@phosphor-icons/react';

import { QuickCreateChoiceChip } from './QuickCreateChoiceChip';
import {
  formatQuickDateLabel,
  clampISODate,
  todayISO,
  toLocalISODate,
} from '../../utils/quickCreateDates';
import pt from '../../locales/pt';

function yesterdayISO() {
  const date = new Date();
  date.setDate(date.getDate() - 1);
  return toLocalISODate(date);
}

/** `.pen` `ds/input/date-quick`. */
export function QuickCreateDateChips({ value, onSelect, onOpenPicker, min, max, ariaLabel }) {
  const today = todayISO();
  const yesterday = yesterdayISO();
  const isToday = value != null && value === today;
  const isYesterday = value != null && value === yesterday;
  const isCustom = value != null && !isToday && !isYesterday;

  return (
    <div className="flex flex-col gap-space-2">
      <span className="type-label text-foreground">{ariaLabel || pt.quickCreate.dateLabel}</span>
      <div
        className="flex flex-wrap items-center gap-space-2"
        role="group"
        aria-label={ariaLabel || pt.quickCreate.dateLabel}
      >
        <QuickCreateChoiceChip
          label={pt.quickCreate.dateToday}
          selected={isToday}
          onSelect={() => onSelect(clampISODate(today, min, max))}
        />
        <QuickCreateChoiceChip
          label={pt.quickCreate.dateYesterday}
          selected={isYesterday}
          onSelect={() => onSelect(clampISODate(yesterday, min, max))}
        />
        <QuickCreateChoiceChip
          label={isCustom ? formatQuickDateLabel(value) : pt.quickCreate.dateOtherLabel}
          selected={isCustom}
          onSelect={onOpenPicker}
          icon={isCustom ? undefined : CalendarBlank}
          ariaHaspopup="dialog"
        />
      </div>
    </div>
  );
}
